export enum TYPE_OF_ACCOUNT_CHECK_EXISTS {
  USERNAME = 'username',
  EMAIL = 'email',
}

export const nameRegex = /^[A-Za-z0-9]+$/;
export const UnVerified = '信箱不存在';
